import { format, formatDistance, isAfter, subDays } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { getLocale } from './fns_locale';

export function getZonedTime(date: Date | number | string, timeZone?: string, showTimeZone?: boolean): string {
    if (!date || !timeZone) {
        return '';
    }

    let formatStr = 'hh:mm a, MMM d, yyyy';

    if (document.dir === 'rtl') {
        formatStr = 'MMM d, yyyy hh:mm a';
    }

    if (showTimeZone) {
        formatStr += ' (O)';
    }

    return formatInTimeZone(date, timeZone, formatStr);
}

export function timeUnix() {
    return Math.floor(Date.now() / 1000);
}

export function timeConversion(duration: number) {
    const portions: string[] = [];

    const msInHour = 1000 * 60 * 60;
    const hours = Math.trunc(duration / msInHour);
    if (hours > 0) {
        portions.push(`${hours}h`);
        duration -= hours * msInHour;
    }

    const msInMinute = 1000 * 60;
    const minutes = Math.trunc(duration / msInMinute);
    if (minutes > 0) {
        portions.push(`${minutes}m`);
        duration -= minutes * msInMinute;
    }

    const seconds = Math.trunc(duration / 1000);
    if (seconds > 0) {
        portions.push(`${seconds}s`);
        duration -= seconds * msInMinute;
    }

    const milliSeconds = Math.trunc(duration);
    if (milliSeconds > 0) {
        portions.push(`${milliSeconds}ms`);
    }

    return portions.join(' ');
}

export const getDateAndTime = (dateStr: string | Date, lang?: string): string => {
    if (!dateStr) {
        return '';
    }

    const date = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
    return format(new Date(date), lang === 'ja' ? 'yyyy/MM/dd, HH:mm:ss' : 'dd/MM/yyyy, HH:mm:ss');
};
export const getDateAndTimeMin = (dateStr: string | Date, lang?: string): string => {
    if (!dateStr) {
        return '';
    }

    const date = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
    return format(new Date(date), lang === 'ja' ? 'yyyy/MM/dd, HH:mm' : 'dd/MM/yyyy, HH:mm');
};

export const getRelativeTime = (dateStr: string | Date, lang?: string): string => {
    const date = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
    const now = new Date();
    if (isAfter(date, subDays(now, 15))) {
        return formatDistance(date, now, {
            locale: getLocale(lang || 'en'),
            includeSeconds: true,
            addSuffix: true,
        });
    }
    return getDateAndTime(date, lang);
};
